import React, { useState } from "react";
import "./ExplorePage.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Howl } from "howler";
import clickSound from "../assets/click.mp3";
import BottomNav from "../BottomNav";

// Asset imports - Ensure these 12 PNGs are in your src/assets folder
import techImg from "../assets/tech.png";
import healthImg from "../assets/health.png";
import businessImg from "../assets/business.png";
import eduImg from "../assets/education.png";
import lifeImg from "../assets/lifestyle.png";
import mediaImg from "../assets/media.png";
import envImg from "../assets/environment.png";
import societyImg from "../assets/society.png";
import mobImg from "../assets/mobility.png";
import infraImg from "../assets/infrastructure.png";
import artsImg from "../assets/arts.png";
import sportsImg from "../assets/sports.png";

const categories = [
  { name: "Technology", image: techImg, class: "btn-tech", path: "technology" },
  { name: "Health", image: healthImg, class: "btn-health", path: "health" },
  { name: "Business", image: businessImg, class: "btn-business", path: "business" },
  { name: "Education", image: eduImg, class: "btn-edu", path: "education" },
  { name: "Lifestyle", image: lifeImg, class: "btn-life", path: "lifestyle" },
  { name: "Media", image: mediaImg, class: "btn-media", path: "media" },
  { name: "Environment", image: envImg, class: "btn-env", path: "environment" },
  { name: "Society", image: societyImg, class: "btn-society", path: "society" },
  { name: "Mobility", image: mobImg, class: "btn-mob", path: "mobility" },
  { name: "Infrastructure", image: infraImg, class: "btn-infra", path: "infrastructure" },
  { name: "Arts", image: artsImg, class: "btn-arts", path: "arts" },
  { name: "Sports", image: sportsImg, class: "btn-sports", path: "sports" },
];

const sound = new Howl({ src: [clickSound], volume: 0.2 });

const ExplorePage = () => {
  const navigate = useNavigate();
  const [loadedImages, setLoadedImages] = useState({});

  const handleClick = (path) => {
    try { sound.play(); } catch (e) {}
    navigate(`/explore/${path}`);
  };

  const handleImageLoad = (name) => {
    setLoadedImages((prev) => ({ ...prev, [name]: true }));
  };

  return (
    <div className="explore-container">
      <h2 className="explore-title">Explore</h2>

      <div className="button-grid">
        {categories.map((cat, index) => {
          const isLoaded = !!loadedImages[cat.name];
          return (
            <motion.button
              key={cat.name}
              className={`explore-button ${cat.class}`}
              onClick={() => handleClick(cat.path)}
              whileTap={{ scale: 0.96 }}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.03, duration: 0.4 }}
            >
              <span>{cat.name}</span>

              {/* Standardized wrapper for uniform image spacing */}
              <div className="explore-img-wrapper">
                {!isLoaded && <div className="explore-img-skeleton" />}
                <img
                  src={cat.image}
                  alt=""
                  className={`explore-card-img ${isLoaded ? "is-loaded" : ""}`}
                  onLoad={() => handleImageLoad(cat.name)}
                />
              </div>
            </motion.button>
          );
        })}
      </div>

      <BottomNav />
    </div>
  );
};

export default ExplorePage;